<div class="tag-list" [class.tag-list--measuring]="!measured()" #container>
  @for (tag of renderedTags(); track $index; let i = $index) {
    @if (expanded() || i < visibleCount() || !measured()) {
      <app-tag data-tag-item size="xs" [color]="tagStyle(tag.tagColor)!.tagColor">
        <app-text size="package-tag" weight="m" [color]="tagStyle(tag.tagColor)!.textColor">{{ tag.tagName }}</app-text>
      </app-tag>
    }
  }
  @if (!expanded() && hiddenCount() > 0) {
    <app-tag
      data-more-badge
      size="xs"
      color="outline-gray2"
      [clickable]="true"
      (clicked)="toggleExpand()"
    >
      <app-text size="package-tag" weight="m" color="gray-700">+{{ hiddenCount() }}</app-text>
    </app-tag>
  }
</div>
